import { request as getList } from './reducers/get-list';
import { request as update } from './reducers/update';
import { request as create } from './reducers/create';

export default {
    GRADES_GET_LIST_REQUEST: getList,
    GRADES_CREATE_REQUEST: create,
    GRADES_UPDATE_REQUEST: update
};
